import {h1, h2, h3, h4, p, div, article, section, span} from 'iblokz-snabbdom-helpers';
import {obj} from 'iblokz-data';

const TAGS = {h1, h2, h3, h4, p, div, article, section, span};

/**
 * Resolve `i18n.pages.home.title` (or plain string) against the active i18n tree.
 */
export const resolveContent = (spec, i18n) => {
	if (spec == null) {
		return '';
	}
	if (typeof spec !== 'string') {
		return String(spec);
	}
	if (spec.indexOf('i18n.') === 0) {
		const path = spec.slice(5).split('.').filter(Boolean);
		const value = obj.sub(i18n, path);
		return value == null ? '' : value;
	}
	return spec;
};

const toParagraphs = (text) => String(text || '')
	.split(/\n\s*\n/)
	.map((chunk) => chunk.replace(/\n/g, ' ').trim())
	.filter(Boolean)
	.map((chunk) => p(chunk));

/**
 * Static layout widget: `content` is an i18n path or literal.
 * Body copy (article / multi-line) becomes a div of `<p>`s for `.content` CSS.
 */
export default ({node, i18n}) => {
	const text = resolveContent(node && node.content, i18n);
	const tagName = ((node && node.tag) || 'div').toLowerCase();
	const tag = TAGS[tagName] || div;
	const bodyTags = tagName === 'article' || tagName === 'div';

	if (bodyTags) {
		const paras = toParagraphs(text);
		return div(paras.length ? paras : []);
	}

	return tag(text);
};
